// extracted by mini-css-extract-plugin
export var available = "itemCards-module--available--79836";
export var borrowed = "itemCards-module--borrowed--8f76c";
export var column = "itemCards-module--column--65531";
export var itemCard = "itemCards-module--itemCard--123b0";
export var itemCard_commentTooltip = "itemCards-module--itemCard_commentTooltip--cf800";
export var itemCard_content = "itemCards-module--itemCard_content--7bb9b";
export var itemCard_dueBack = "itemCards-module--itemCard_dueBack--9681d";
export var itemCard_footer = "itemCards-module--itemCard_footer--c43f3";
export var itemCard_header = "itemCards-module--itemCard_header--16f0a";
export var itemCard_icons = "itemCards-module--itemCard_icons--a103a";
export var itemCard_image = "itemCards-module--itemCard_image--609db";
export var itemCard_info = "itemCards-module--itemCard_info--aebe4";
export var itemCard_keyValue = "itemCards-module--itemCard_keyValue--f9329";
export var itemCard_location = "itemCards-module--itemCard_location--54d52";
export var itemCard_locationDue = "itemCards-module--itemCard_locationDue--907d9";
export var itemCard_locationIcon = "itemCards-module--itemCard_locationIcon--7baac";
export var itemCard_owner = "itemCards-module--itemCard_owner--f888f";
export var itemCard_status = "itemCards-module--itemCard_status--450d9";
export var itemCard_statusLabel = "itemCards-module--itemCard_statusLabel--870ac";
export var itemCard_subheader = "itemCards-module--itemCard_subheader--ee221";
export var itemCard_top = "itemCards-module--itemCard_top--18359";
export var loaned = "itemCards-module--loaned--580a5";
export var locationIcon = "itemCards-module--locationIcon--ffd63";
export var locationTrackingIcon = "itemCards-module--locationTrackingIcon--d1dd9";
export var pending = "itemCards-module--pending--d0379";
export var unavailable = "itemCards-module--unavailable--abe7c";
export var warehouseIcon = "itemCards-module--warehouseIcon--b2a17";